module.exports = __webpack_public_path__ + "static/media/facebook.5d6ea38a.png";